import { render } from "./News20.vue?vue&type=template&id=227e4e2d&scoped=true"
import script from "./News20.vue?vue&type=script&lang=js"
export * from "./News20.vue?vue&type=script&lang=js"

import "./News20.vue?vue&type=style&index=0&id=227e4e2d&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-227e4e2d"]])

export default __exports__